import React, { useEffect, useState, useRef, useMemo } from 'react';
import '../../style.css';
import Avatar from '@mui/material/Avatar';
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import { ReactComponent as GreenDot } from '../../../../assets/images/greendot.svg';
import { ReactComponent as GreyDot } from '../../../../assets/images/greydot.svg';
import { suspendGroupList } from '../../../../store/features/listSuspendedGroup';
import { ReactComponent as Team01 } from '../../../../assets/images/team01.svg';
import { unSuspendedGroupApi } from '../../../../store/features/unSuspendGroup';
import { ReactComponent as EmptyGroupIcon } from '../../../../assets/images/emptyGroupIcon.svg';
import SearchInput from '../../../common/SearchInputField';
import Loader from '../../../../assets/Loader'
import { useNavigate } from 'react-router-dom';
import TeamManagementSkeleton from '../TeamManagementSkeleton';
import {
  getTeamMgmtPeek,
  setTeamMgmtPeek,
  TEAM_MGMT_CACHE_TABS,
} from '../../../../utils/teamManagementViewCache';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Button,
  TablePagination,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

const capitalize = (str, lower = false) => (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());

const chracterPosition = (alphabet) => {
  const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};

const colorCodesForAvatar = [
  '#405261', // A
  '#FF4D4F', // B
  '#FA541C', // C
  '#FA8C16', // D
  '#FAAD14', // E
  '#EB2F96', // F
  '#FADB14', // G
  '#A0D911', // H
  '#52C41A', // I
  '#5CDBD3', // J
  '#9254DE', // K
  '#F759AB', // L
  '#2F54EB', // M
  '#722ED1', // N
  '#1890FF', // O
  '#13C2C2', // P
  '#2DB7F5', // Q
  '#19BE6B', // R
  '#30A745', // S
  '#FA8C16', // T
  '#FAAD14', // U
  '#9254DE', // V
  '#F759AB', // W
  '#13C2C2', // X
  '#722ED1', // Y
  '#2DB7F5', // Z
];

function buildSuspendedGroupRows(rawList) {
  if (!Array.isArray(rawList) || !rawList.length) return [];
  return rawList.map((item) => ({
    id: item?.id,
    img: item?.group_image,
    name: item?.title,
    selected: false,
    menu: '...',
    ActiveUser: 'Suspended',
    DotColor: <GreyDot />,
  }));
}

function SuspendedGroup(props) {
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;
  const groupsPeek = getTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.SUSPENDED_GROUPS);
  const initialRows =
    groupsPeek?.rawData !== undefined
      ? buildSuspendedGroupRows(groupsPeek.rawData)
      : [];

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState(initialRows);
  const [data, setData] = useState(initialRows);
  const [activeRowId, setActiveRowId] = useState(null);
  const [isLoading, setIsLoading] = useState(groupsPeek?.rawData === undefined);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRowForMenu] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const uID = userData.response?.user?._id;
  const uRole = userData.response?.user?.role_name;

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setPage(0);
    const filteredResults = data.filter((row) => row.name.toLowerCase().includes(query));
    setFilteredData(filteredResults);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows = useMemo(() => {
    return filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);
  const toolbarRef = useRef(null);
  const [toolbarHeight, setToolbarHeight] = useState(0);
  useEffect(() => {
    if (toolbarRef.current) {
      setToolbarHeight(toolbarRef.current.offsetHeight);
    }
  }, [visibleRows?.length]);

  // Calculate dynamic table height
  const tableContainerHeight = useMemo(() => {
    return `calc(100vh - ${390 + toolbarHeight}px)`;
  }, [toolbarHeight]);

  const getSuspendedList = async () => {
    const listsuspendedUser = dispatch(
      suspendGroupList(),
    );
    listsuspendedUser
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          setIsLoading(false);
        } else if (data?.payload?.status === 200) {
          const list = Array.isArray(data.payload.data) ? data.payload.data : [];
          if (businessId) {
            setTeamMgmtPeek(businessId, TEAM_MGMT_CACHE_TABS.SUSPENDED_GROUPS, list);
          }
          const outputarray = buildSuspendedGroupRows(list);
          setData(outputarray);
          setFilteredData(outputarray);
          setIsLoading(false);
        } else if (data?.payload?.status === 500) {
          setIsLoading(false);
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 401) {
          setIsLoading(false);
          toast.error('Login Expired. Please login  and try again.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
          navigate('/login');
        }
      })
      .catch(async (error) => {
        setIsLoading(false);
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const unSuspendedHandler = async (rowId) => {
    const unSuspendedGroup = dispatch(
      unSuspendedGroupApi({
        id: rowId
      }),
    );
    unSuspendedGroup
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data.payload.status === 200) {
          toast.success(data?.payload?.message);
          getSuspendedList();
          props.onSuspenseChange()
          handleMenuClose();
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  useEffect(() => {
    getSuspendedList();
  }, []);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  const handleRowClick = (row) => {
    setActiveRowId(row.id);
  };

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRowForMenu(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRowForMenu(null);
  };

  if (isLoading) {
    return <TeamManagementSkeleton isGroupsTab={true} />;
  }

  const headCells = [
    { id: "name", label: t.NAMETB },
    { id: "status", label: t.STATUSTB },
    { id: "actions", label: "" },
  ];

  return (
    <>
      <div className="team-container">
        <SearchInput
          title=""
          placeholder="Search"
          value={searchQuery}
          onChange={handleSearchInputChange}
          className="SearchInputField-teamsection"
        />
      </div>
      <div className="Team-Section-Content-Container">
        {parseInt(filteredData?.length, 10) < 1 ? (
          <div className="NoSuspendedAgent-main-Conatiner">
            <div className="TeamChatBot-Main-Container">
              <EmptyGroupIcon />
              <p className="Chatbot-devploment">
                {t.NOAVAILABLEGROUPSSUSPENDED}
              </p>
            </div>
          </div>
        ) : (
          <>
            <TableContainer
              sx={{
                boxShadow: "none",
                flex: 1,
                marginTop: "2px",
                marginBottom: "40px",
                height: tableContainerHeight,
                overflowY: "auto",
              }}
            >
              <Table stickyHeader sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <TableHead>
                  <TableRow
                    sx={{
                      zIndex: 15,
                      bottom: 0,
                      '& th': {
                        color: '#405261',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 400,
                        paddingTop: '0px',
                        paddingBottom: '0px',

                      },
                    }}
                  >
                    {headCells.map((headCell, index) => (
                      <TableCell
                        key={headCell.id}
                        sx={{
                          paddingLeft: index === 0 ? '0px' : '16px',
                          paddingTop: '0px',
                          paddingBottom: '9px !important',

                          lineHeight: '0',
                        }}
                      >
                        <Typography sx={{ fontSize: '12px', fontWeight: 400, margin: 0 }}>
                          {headCell.label}
                        </Typography>
                      </TableCell>

                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {visibleRows.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      onClick={() => handleRowClick(row)}
                      selected={activeRowId === row.id}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#F9FAFA",
                        },
                        "&:hover td": {
                          backgroundColor: "#F9FAFA",
                        },
                        "& td": {
                          height: "4rem !important", py: 0, verticalAlign: "middle",
                          color: "#405261",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,

                        },
                      }}
                    >
                      <TableCell style={{ paddingLeft: 0 }}>
                        <div className="team-table-img">
                          {row.img ? (
                            <Avatar
                              src={row.img}
                              alt="users logo"
                              sx={{ width: 32, height: 32 }}
                            />
                          ) : (
                            <Avatar
                              sx={{
                                width: 32,
                                height: 32,
                                fontSize: '16px',
                                bgcolor: colorCodesForAvatar[
                                  chracterPosition(row.name.substring(0, 1).toUpperCase())
                                ],
                              }}
                            >
                              {row.name.substring(0, 1).toUpperCase()}
                            </Avatar>
                          )}
                          <p className="team-table-rowtext">
                            {capitalize(row.name)}
                          </p>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className="team-activeuser">
                          {row.DotColor}
                          {row.ActiveUser}
                        </div>
                      </TableCell>
                      <TableCell padding="none">
                        {(row.name !== 'General' && (uRole === 'admin' || uRole === 'admin_with_billing' || row.id === uID)) && (
                          <IconButton
                            onClick={(e) => handleMenuClick(e, row)}
                            size="small"
                            sx={{ ml: 1, "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }}
                          >
                            <MoreHorizIcon />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                width: "100%",
                background: "#fff",
                zIndex: 10,
                padding: "16px 24px",
                borderTop: "1px solid #E5E9EC",
              }}
            >
              <TablePagination
                component="div"
                count={filteredData.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count }) => (
                  <Typography
                    sx={{
                      color: "#405261",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "18px",
                    }}
                  >
                    Suspended Groups {from}-{to}
                  </Typography>
                )}
                ActionsComponent={(props) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginLeft: "auto",
                    }}
                  >
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page - 1)}
                      disabled={props.page === 0}
                      sx={{
                        width: "128px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",
                        background: "#FFF",
                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",
                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {
                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      onClick={(e) => props.onPageChange(e, props.page + 1)}
                      disabled={
                        props.page >= Math.ceil(props.count / rowsPerPage) - 1
                      }
                      sx={{
                        width: "88px",
                        height: "40px",
                        flexShrink: 0,
                        borderRadius: "8px",
                        border: "1px solid #D5DCE1",
                        boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
                        color: "#405261",
                        backgroundColor: "#FFFFFF",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "18px",
                        textTransform: "none",
                        "&:not(.Mui-disabled):hover": {
                          backgroundColor: "#FFFFFF",
                          borderColor: "#C5CED6",
                        },
                        "&.Mui-disabled": {
                          color: "#93A1B0",
                          border: "1px solid #C5CED6",
                          bgcolor: "#F9FAFA",
                        },
                      }}
                    >
                      Next
                    </Button>
                  </Box>
                )}
                sx={{
                  ".MuiTablePagination-toolbar": {
                    padding: 0,
                    minHeight: "unset",
                    display: "flex",
                    justifyContent: "space-between",
                  },
                  ".MuiTablePagination-spacer": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectLabel": {
                    display: "none",
                  },
                  ".MuiTablePagination-select": {
                    display: "none",
                  },
                  ".MuiTablePagination-selectIcon": {
                    display: "none",
                  },
                }}
              />
            </Box>
          </>
        )}

        {/* Actions Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          PaperProps={{
            elevation: 0,
            sx: {
              filter: "none",
              color: '#405261',
              mt: '-5px',
              width: 200,
              paddingX: "8px",
              borderRadius: "8px", // ✅ your custom border radius
              border: "1px solid #D5DCE1", // ✅ your custom border

              boxShadow: "0 15px 20px 0 rgba(6, 21, 34, 0.05)", // ✅ soft shadow
              "& .MuiMenuItem-root": {
                px: "8px",
                py: 1,
                fontSize: '14px',
                fontFamily: 'Inter',
                color: '#405261',

                "&:hover": { color: "#061522", borderRadius: "8px", background: "#F9FAFA !important" },
              },
            },
          }}
        >
          <MenuItem onClick={() => { unSuspendedHandler(selectedRow?.id); }}>
            Activate Group
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}

export default SuspendedGroup;